var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 4.90625H13.3335V6.01736H8.3335V4.90625Z",
    fill: "#7D7688"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 7.12891H13.3335V8.24002H8.3335V7.12891Z",
    fill: "#7D7688"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 9.35156H13.3335V10.4627H8.3335V9.35156Z",
    fill: "#7D7688"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 11.5703H13.3335V12.6814H8.3335V11.5703Z",
    fill: "#7D7688"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 13.793H13.3335V14.9041H8.3335V13.793Z",
    fill: "#7D7688"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 4.90625H7.22244V6.01736H6.11133V4.90625Z",
    fill: "#7D7688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 7.12891H7.22244V8.24002H6.11133V7.12891Z",
    fill: "#7D7688"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 9.35156H7.22244V10.4627H6.11133V9.35156Z",
    fill: "#7D7688"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 11.5703H7.22244V12.6814H6.11133V11.5703Z",
    fill: "#7D7688"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11133 13.793H7.22244V14.9041H6.11133V13.793Z",
    fill: "#7D7688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 1.57031H4.44461C4.14992 1.57031 3.86731 1.68738 3.65893 1.89575C3.45056 2.10412 3.3335 2.38674 3.3335 2.68142V18.237C3.3335 18.5317 3.45056 18.8143 3.65893 19.0227C3.86731 19.231 4.14992 19.3481 4.44461 19.3481H15.5557C15.8504 19.3481 16.133 19.231 16.3414 19.0227C16.5498 18.8143 16.6668 18.5317 16.6668 18.237V2.68142C16.6668 2.38674 16.5498 2.10412 16.3414 1.89575C16.133 1.68738 15.8504 1.57031 15.5557 1.57031ZM15.5557 18.237H4.44461V2.68142H15.5557V18.237Z",
    fill: "#7D7688"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.34402515c03b77139c1bc358e47062d3.svg";
export { ForwardRef as ReactComponent };